<div class="version-update-wrapper">
  <fa-icon id="wilson-logo" [icon]="faWilson" size="5x"></fa-icon>

  @if (updateRequired) {
    <h1>{{ 'versionUpdate.updateRequired.header' | translate }}</h1>
    <p>{{ 'versionUpdate.updateRequired.message' | translate }}</p>
  }

  @if (!updateRequired) {
    <h1>{{ 'versionUpdate.updateOptional.header' | translate }}</h1>
    <p>{{ 'versionUpdate.updateOptional.message' | translate }}</p>
  }

  @if (storeUrl) {
    <a [href]="storeUrl" id="store-link">
      <ion-button expand="block">
        {{ 'version_update.navigate_to_app_store' | translate }}
      </ion-button>
    </a>
  }

  @if (!updateRequired) {
    <ion-button
      fill="clear"
      color="dark"
      (click)="dismiss()"
      expand="block"
      id="dismiss-button"
    >
      {{ 'versionUpdate.updateOptional.button' | translate }}
    </ion-button>
  }
</div>
